import { postToAgents } from "./PlaybookApi";
import UtilityService from "./UtilityService";

const CHANGE_REQUEST_STATUS_DESCRIPTIONS = {
	pending: { label: "Pending", tone: "warning" },
	approved: { label: "Approved", tone: "success" },
	rejected: { label: "Rejected", tone: "danger" },
	withdrawn: { label: "Withdrawn", tone: "neutral" },
};

const PlaybookChangeRequestService = {
	/**
	 * An agent's held changes, pending first, then the last twenty decided.
	 *
	 * @param {Object} params { playbookId }
	 * @return {Promise<Array>}
	 */
	listChangeRequests({ playbookId }) {
		return postToAgents({ operationId: "listPlaybookChangeRequests", body: { playbookId } });
	},

	/**
	 * Approves or rejects a held change. Resolves to the agent's change requests.
	 *
	 * @param {Object} params { requestId, isApproved, reason }
	 * @return {Promise<Array>}
	 */
	decideChangeRequest({ requestId, isApproved, reason }) {
		return postToAgents({ operationId: "decidePlaybookChangeRequest", body: { requestId, isApproved, reason } });
	},

	/**
	 * Withdraws the viewer's own held change. Resolves to the agent's change requests.
	 *
	 * @param {Object} params { requestId }
	 * @return {Promise<Array>}
	 */
	withdrawChangeRequest({ requestId }) {
		return postToAgents({ operationId: "withdrawPlaybookChangeRequest", body: { requestId } });
	},

	/**
	 * Plain words for an integrity verdict.
	 *
	 * @param {Object} params
	 * @param {String} params.verdict
	 * @return {String}
	 */
	describeIntegrityVerdict({ verdict }) {
		const descriptions = {
			additive: "Additive",
			conflicts: "Conflicts with the playbook",
			changes_nature: "Changes what the playbook is for",
			not_reviewed: "Not checked",
		};
		const description = UtilityService.labelFor({ labels: descriptions, key: verdict });
		return description;
	},

	/**
	 * The label and tone for a held change's status badge.
	 *
	 * @param {Object} params
	 * @param {String} params.status pending | approved | rejected | withdrawn
	 * @return {Object} { label, tone }
	 */
	describeChangeRequestStatus({ status }) {
		const description = CHANGE_REQUEST_STATUS_DESCRIPTIONS[status] || { label: status, tone: "neutral" };
		return description;
	},
};

export default PlaybookChangeRequestService;
